var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _VaryingTempoMap_instances, _VaryingTempoMap_terminator, _VaryingTempoMap_adapter, _VaryingTempoMap_ppqnCache, _VaryingTempoMap_secondsCache, _VaryingTempoMap_rebuildCache, _VaryingTempoMap_ppqnToSecondsPositive, _VaryingTempoMap_absoluteSecondsToPPQN;
import { PPQN, TempoChangeGrid } from "@opendaw/lib-dsp";
import { BinarySearch, NumberComparator, quantizeCeil, Terminator } from "@opendaw/lib-std";
/**
 * TempoMap implementation that handles varying tempo (tempo automation).
 * Steps through at TempoChangeGrid intervals to match BlockRenderer behavior.
 */
export class VaryingTempoMap {
    constructor(adapter) {
        _VaryingTempoMap_instances.add(this);
        _VaryingTempoMap_terminator.set(this, new Terminator());
        _VaryingTempoMap_adapter.set(this, void 0);
        _VaryingTempoMap_ppqnCache.set(this, []);
        _VaryingTempoMap_secondsCache.set(this, []);
        __classPrivateFieldSet(this, _VaryingTempoMap_adapter, adapter, "f");
        __classPrivateFieldGet(this, _VaryingTempoMap_terminator, "f").ownAll(adapter.box.bpm.subscribe(() => __classPrivateFieldGet(this, _VaryingTempoMap_instances, "m", _VaryingTempoMap_rebuildCache).call(this)), adapter.catchupAndSubscribeTempoAutomation(() => __classPrivateFieldGet(this, _VaryingTempoMap_instances, "m", _VaryingTempoMap_rebuildCache).call(this)));
    }
    terminate() {
        __classPrivateFieldGet(this, _VaryingTempoMap_terminator, "f").terminate();
    }
    getTempoAt(position) {
        const storageBpm = __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").box.bpm.getValue();
        return __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").tempoTrackEvents.mapOr(collection => collection.valueAt(position, storageBpm), storageBpm);
    }
    ppqnToSeconds(position) {
        if (position < 0) {
            return -__classPrivateFieldGet(this, _VaryingTempoMap_instances, "m", _VaryingTempoMap_ppqnToSecondsPositive).call(this, -position);
        }
        return __classPrivateFieldGet(this, _VaryingTempoMap_instances, "m", _VaryingTempoMap_ppqnToSecondsPositive).call(this, position);
    }
    secondsToPPQN(time) {
        return __classPrivateFieldGet(this, _VaryingTempoMap_instances, "m", _VaryingTempoMap_absoluteSecondsToPPQN).call(this, time);
    }
    intervalToSeconds(fromPPQN, toPPQN) {
        if (fromPPQN >= toPPQN) {
            return 0.0;
        }
        return __classPrivateFieldGet(this, _VaryingTempoMap_instances, "m", _VaryingTempoMap_ppqnToSecondsPositive).call(this, toPPQN) - __classPrivateFieldGet(this, _VaryingTempoMap_instances, "m", _VaryingTempoMap_ppqnToSecondsPositive).call(this, fromPPQN);
    }
    intervalToPPQN(fromSeconds, toSeconds) {
        if (fromSeconds >= toSeconds) {
            return 0.0;
        }
        const fromPPQN = __classPrivateFieldGet(this, _VaryingTempoMap_instances, "m", _VaryingTempoMap_absoluteSecondsToPPQN).call(this, fromSeconds);
        const toPPQN = __classPrivateFieldGet(this, _VaryingTempoMap_instances, "m", _VaryingTempoMap_absoluteSecondsToPPQN).call(this, toSeconds);
        return toPPQN - fromPPQN;
    }
    subscribe(observer) {
        const terminator = new Terminator();
        terminator.ownAll(__classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").box.bpm.subscribe(() => observer(this)), __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").catchupAndSubscribeTempoAutomation(() => observer(this)));
        return terminator;
    }
}
_VaryingTempoMap_terminator = new WeakMap(), _VaryingTempoMap_adapter = new WeakMap(), _VaryingTempoMap_ppqnCache = new WeakMap(), _VaryingTempoMap_secondsCache = new WeakMap(), _VaryingTempoMap_instances = new WeakSet(), _VaryingTempoMap_rebuildCache = function _VaryingTempoMap_rebuildCache() {
    __classPrivateFieldGet(this, _VaryingTempoMap_ppqnCache, "f").length = 0;
    __classPrivateFieldGet(this, _VaryingTempoMap_secondsCache, "f").length = 0;
    const tempoEvents = __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").tempoTrackEvents;
    if (tempoEvents.isEmpty()) {
        return;
    }
    const collection = tempoEvents.unwrap();
    if (collection.events.isEmpty()) {
        return;
    }
    const events = collection.events.asArray();
    const storageBpm = __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").box.bpm.getValue();
    const entries = [{ ppqn: 0, seconds: 0, bpm: collection.valueAt(0, storageBpm) }];
    let accumulatedSeconds = 0.0;
    let currentPPQN = 0.0;
    for (const event of events) {
        const eventPosition = event.position;
        if (eventPosition <= currentPPQN) {
            continue;
        }
        while (currentPPQN < eventPosition) {
            const currentBpm = collection.valueAt(currentPPQN, storageBpm);
            const nextGrid = quantizeCeil(currentPPQN, TempoChangeGrid);
            const segmentEnd = nextGrid <= currentPPQN ? nextGrid + TempoChangeGrid : nextGrid;
            const actualEnd = Math.min(segmentEnd, eventPosition);
            accumulatedSeconds += PPQN.pulsesToSeconds(actualEnd - currentPPQN, currentBpm);
            currentPPQN = actualEnd;
        }
        entries.push({ ppqn: eventPosition, seconds: accumulatedSeconds, bpm: collection.valueAt(eventPosition, storageBpm) });
    }
    __classPrivateFieldGet(this, _VaryingTempoMap_ppqnCache, "f").push(...entries);
    const sortedBySeconds = entries.slice().sort((a, b) => a.seconds - b.seconds);
    __classPrivateFieldGet(this, _VaryingTempoMap_secondsCache, "f").push(...sortedBySeconds);
}, _VaryingTempoMap_ppqnToSecondsPositive = function _VaryingTempoMap_ppqnToSecondsPositive(position) {
    if (position <= 0) {
        return 0.0;
    }
    const storageBpm = __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").box.bpm.getValue();
    const tempoEvents = __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").tempoTrackEvents;
    if (tempoEvents.isEmpty()) {
        return PPQN.pulsesToSeconds(position, storageBpm);
    }
    const collection = tempoEvents.unwrap();
    if (collection.events.isEmpty()) {
        return PPQN.pulsesToSeconds(position, storageBpm);
    }
    let startPPQN = 0.0;
    let startSeconds = 0.0;
    if (__classPrivateFieldGet(this, _VaryingTempoMap_ppqnCache, "f").length > 0) {
        const index = BinarySearch.rightMostMapped(__classPrivateFieldGet(this, _VaryingTempoMap_ppqnCache, "f"), position, NumberComparator, (entry) => entry.ppqn);
        if (index >= 0) {
            const entry = __classPrivateFieldGet(this, _VaryingTempoMap_ppqnCache, "f")[index];
            startPPQN = entry.ppqn;
            startSeconds = entry.seconds;
            if (index === __classPrivateFieldGet(this, _VaryingTempoMap_ppqnCache, "f").length - 1) {
                return startSeconds + PPQN.pulsesToSeconds(position - startPPQN, entry.bpm);
            }
        }
    }
    let accumulatedSeconds = startSeconds;
    let currentPPQN = startPPQN;
    while (currentPPQN < position) {
        const currentBpm = collection.valueAt(currentPPQN, storageBpm);
        const nextGrid = quantizeCeil(currentPPQN, TempoChangeGrid);
        const segmentEnd = nextGrid <= currentPPQN ? nextGrid + TempoChangeGrid : nextGrid;
        const actualEnd = Math.min(segmentEnd, position);
        accumulatedSeconds += PPQN.pulsesToSeconds(actualEnd - currentPPQN, currentBpm);
        currentPPQN = actualEnd;
    }
    return accumulatedSeconds;
}, _VaryingTempoMap_absoluteSecondsToPPQN = function _VaryingTempoMap_absoluteSecondsToPPQN(targetSeconds) {
    if (targetSeconds <= 0) {
        return 0.0;
    }
    const storageBpm = __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").box.bpm.getValue();
    const tempoEvents = __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").tempoTrackEvents;
    if (tempoEvents.isEmpty()) {
        return PPQN.secondsToPulses(targetSeconds, storageBpm);
    }
    const collection = tempoEvents.unwrap();
    if (collection.events.isEmpty()) {
        return PPQN.secondsToPulses(targetSeconds, storageBpm);
    }
    let startPPQN = 0.0;
    let startSeconds = 0.0;
    if (__classPrivateFieldGet(this, _VaryingTempoMap_secondsCache, "f").length > 0) {
        const index = BinarySearch.rightMostMapped(__classPrivateFieldGet(this, _VaryingTempoMap_secondsCache, "f"), targetSeconds, NumberComparator, (entry) => entry.seconds);
        if (index >= 0) {
            const entry = __classPrivateFieldGet(this, _VaryingTempoMap_secondsCache, "f")[index];
            startPPQN = entry.ppqn;
            startSeconds = entry.seconds;
            if (index === __classPrivateFieldGet(this, _VaryingTempoMap_secondsCache, "f").length - 1) {
                return startPPQN + PPQN.secondsToPulses(targetSeconds - startSeconds, entry.bpm);
            }
        }
    }
    let accumulatedSeconds = startSeconds;
    let accumulatedPPQN = startPPQN;
    while (accumulatedSeconds < targetSeconds) {
        const currentBpm = collection.valueAt(accumulatedPPQN, storageBpm);
        const nextGrid = quantizeCeil(accumulatedPPQN, TempoChangeGrid);
        const segmentEnd = nextGrid <= accumulatedPPQN ? nextGrid + TempoChangeGrid : nextGrid;
        const segmentPPQN = segmentEnd - accumulatedPPQN;
        const segmentSeconds = PPQN.pulsesToSeconds(segmentPPQN, currentBpm);
        if (accumulatedSeconds + segmentSeconds >= targetSeconds) {
            const remainingSeconds = targetSeconds - accumulatedSeconds;
            accumulatedPPQN += PPQN.secondsToPulses(remainingSeconds, currentBpm);
            break;
        }
        accumulatedSeconds += segmentSeconds;
        accumulatedPPQN = segmentEnd;
    }
    return accumulatedPPQN;
};
